export default "__VITE_ASSET__BdGIQ1cY__"